// @generated by protoc-gen-connect-es v0.10.1 with parameter "target=ts"
// @generated from file src/protos/analysis_management/analysis.student.apis.proto (package geneo.analysis.student.apis, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { FetchOverAllAnalysisStatsRequest, FetchOverAllAnalysisStatsResponse, FetchOverAllAnalysisStatsV2Request, FetchOverAllAnalysisStatsV2Response, FetchSubjectAnalysisStatsRequest, FetchSubjectAnalysisStatsResponse, FetchSubjectAnalysisStatsV2Request, FetchSubjectAnalysisStatsV2Response } from "./analysis.student.apis_pb";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service geneo.analysis.student.apis.StudentAnalysisAPIServiceV1
 */
export const StudentAnalysisAPIServiceV1 = {
  typeName: "geneo.analysis.student.apis.StudentAnalysisAPIServiceV1",
  methods: {
    /**
     * @generated from rpc geneo.analysis.student.apis.StudentAnalysisAPIServiceV1.fetchOverAllAnalysisStats
     */
    fetchOverAllAnalysisStats: {
      name: "fetchOverAllAnalysisStats",
      I: FetchOverAllAnalysisStatsRequest,
      O: FetchOverAllAnalysisStatsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.analysis.student.apis.StudentAnalysisAPIServiceV1.fetchSubjectAnalysisStats
     */
    fetchSubjectAnalysisStats: {
      name: "fetchSubjectAnalysisStats",
      I: FetchSubjectAnalysisStatsRequest,
      O: FetchSubjectAnalysisStatsResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

/**
 * @generated from service geneo.analysis.student.apis.StudentAnalysisAPIServiceV2
 */
export const StudentAnalysisAPIServiceV2 = {
  typeName: "geneo.analysis.student.apis.StudentAnalysisAPIServiceV2",
  methods: {
    /**
     * @generated from rpc geneo.analysis.student.apis.StudentAnalysisAPIServiceV2.fetchOverAllAnalysisStats
     */
    fetchOverAllAnalysisStats: {
      name: "fetchOverAllAnalysisStats",
      I: FetchOverAllAnalysisStatsV2Request,
      O: FetchOverAllAnalysisStatsV2Response,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.analysis.student.apis.StudentAnalysisAPIServiceV2.fetchSubjectAnalysisStats
     */
    fetchSubjectAnalysisStats: {
      name: "fetchSubjectAnalysisStats",
      I: FetchSubjectAnalysisStatsV2Request,
      O: FetchSubjectAnalysisStatsV2Response,
      kind: MethodKind.Unary,
    },
  }
} as const;

